<template>
  <div>
    <div class="loading" v-if="isLoading">
      <b-loading :is-full-page="true" :active="true"></b-loading>
    </div>
    <div v-else>
      <section class="activate-membership section">
          <div class="container">
            <h1 class="title page-title has-padding-v-50 is-4 has-text-centered"> {{ type.toUpperCase() }} PRODUCT</h1>
            <div class="is-alert" v-if="errors.length"> {{ errors[0] }} </div>
            <div class="is-success" v-if="noterrors.length" style="color:green;"> {{ noterrors[0] }} </div>
      <!-- Item Edit Form -->
      <div id="itemform" class="column billing-form has-text-white has-shadow">

          <div class="field">
              <label class="label">Product Name:</label>
              <div class="control">
                  <input class="input" v-model="item.title" name="title" type="text">
              </div>
          </div>

          <div class="field">
              <label class="label">Product Billing Type:</label>
              <div class="control">
                  <div class="select">
                      <select class="input" v-model="item.type" name="type" @change="timeChange">
                          <option value="One Time">One-off</option>
                          <option value="Recurring">Subscription</option>
                          <option value="Per Usage">Per Usage</option>
                      </select>
                  </div>
              </div>
          </div>

          <div class="field" id="field_frequency" v-show="isRecurring">
              <label class="label">Product Frequency</label>
                  <div class="control">
                      <div class="select">
                          <select class="input" v-model="item.frequency" name="frequency">
                            <option value="Minute">Minute</option>
                            <option value="Hourly">Hour</option>
                            <option value="Daily">Day</option>
                            <option value="Weekly">Week</option>
                            <option value="Monthly">Month</option>
                            <option value="Quaterly">Quarter</option>
                            <option value="Yearly">Year</option>
                          </select>
                      </div>
                </div>
          </div>

          <div class="field">
              <label class="label">Product Category:</label>
              <div class="control">
                  <div class="select">
                      <select class="input" v-model="item.category" name="category">
                          <option value="applicant">Applicant Management</option>
                          <option value="properties">Properties</option>
                          <option value="website">My BestAgent Website</option>
                          <option value="sales">Sales Progression</option>
                          <option value="crm">CRM</option>
                          <option value="other">All Other Services</option>
                      </select>
                  </div>
              </div>
          </div>

          <div class="field">
              <label class="label">Marketplace Price:</label>
              <div class="control has-icons-left has-icons-right">
                  <input class="input is-success" type="number" v-model="item.price" name="price" @change="priceChange">
                  <span class="icon is-small is-left">
                      <i class="fas fa-pound-sign"></i>
                  </span>
              </div>
          </div>
          <div class="field">
              <label class="label">Net Price after Commission:</label>
              <div class="control has-icons-left has-icons-right">
                  <input class="input is-success" type="number" v-model="priceWithCommission" name="price" disabled="disabled">
                  <span class="icon is-small is-left">
                      <i class="fas fa-pound-sign"></i>
                  </span>
              </div>
          </div>

          <div class="field">
              <label class="label">Commission Rate:</label>
              <div class="control">
                  <div class="select">
                      <select class="input" v-model="item.commission" name="commission" @change="priceChange">
                          <option value="software">Software as a service (20%)</option>
                          <option value="other">All other products (10%)</option>
                      </select>
                  </div>
              </div>
          </div>


          <!-- Logo -->
          <!-- <editable-item component="editable-image" v-model="item.img" title="Logo" @isEditView="true"></editable-item> -->

          <div class="field">
              <label class="label">Description:</label>
              <div class="control">
                  <textarea class="input" v-model="item.description" name="description" style="height:100px"> </textarea>
              </div>
          </div>

          <div class="field">
              <label class="label">Message after Activation:</label>
              <div class="control">
                  <textarea class="input" v-model="item.msg" name="msg" style="height:100px"> </textarea>
              </div>
          </div>

          <div class="field" id="field_active" v-if="type == 'edit'">
              <label class="label">Live:
                <span v-if="item.active === true" style="color:green">Yes</span>
                <span style="color:red" v-else>No</span>
              </label>
          </div>
          <!-- Buttons -->
          <div class="field is-grouped">
              <div class="control">
                  <button class="button is-danger" id="btndel" @click="delItem()" v-if="type == 'edit'">Remove</button>
                  <button class="button is-link" id="btncancel" @click="$router.push('/')">Cancel</button>
                  <button class="button is-warning" id="btnsubmit" @click="saveItem()">Submit</button>
              </div>
          </div>

      </div>
      </div>
    </section>
    </div>
  </div>
</template>

<script>
import api from '../libs/api';
import EditableItem from '../components/editable-items/EditableItem.vue';

export default {
  name: 'billingItem',
  data: function() {
    return {
      priceWithCommission: 0,
      isLoading: true,
      type: 'new',
      isRecurring: false,
      items: [],
      item: {},
      noterrors: [],
      errors: []
    };
  },
  components: {
    'editable-item': EditableItem
  },
  async created()  {
    const that = this;
    if (!that.$route.params.id || that.$route.params.id != 'new') {
      this.items = await api({
        endpoint: `${process.env.VUE_APP_API}/suppliers`,
        path: '/billing',
        method: 'POST',
        body: {
          action: 'list'
        }
      });
      this.item = this.items.filter(i => {
        return i.itemId == that.$route.params.id
      });
      this.item = this.item[0];
      if (!this.item.commission) {
        this.item.commission = 'other';
      }
      this.type = 'edit';
      this.priceChange();
    }
    this.isLoading = false;
  },
  methods: {
    async saveItem() {
      const that = this;
      this.noterrors = [];
      this.isLoading = true;
      const action = this.type == 'new' ? 'add' : 'edit';

      const saved = await api({
        endpoint: `${process.env.VUE_APP_API}/suppliers`,
        path: '/billing',
        method: 'POST',
        body: {
          action,
          item: this.item
        }
      });
      this.noterrors.push("Saved with success!");
      this.isLoading = false;
      this.$router.push('/');
      //setTimeout(function(){
      //  that.$router.push('/');
      //},1000);
    },
    async delItem() {
      const that = this;
      this.isLoading = true;
      const del = await api({
        endpoint: `${process.env.VUE_APP_API}/suppliers`,
        path: '/billing',
        method: 'POST',
        body: {
          action: 'del',
          item: this.item
        }
      });
      this.isLoading = false;
      setTimeout(function(){
        that.$router.push('/');
      },1000);
    },
    priceChange: function(event) {
      const commissions = {
        "software": .2,
        "other": .1
      };
      const commission = this.item.commission && commissions[this.item.commission] ? commissions[this.item.commission] : 0;
      this.priceWithCommission = parseFloat(this.item.price) - (parseFloat(this.item.price) * commission);
    },
    timeChange: function(event) {
        const value = event.target.value;
        if (value === 'Recurring') {
            this.isRecurring = true;
        } else {
            this.isRecurring = false;
        }
    },
  },
};
</script>

<style>
  .spinner {
    position: absolute;
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    background-color: white;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>
